// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-Container_cls1__eob+5","cls2":"VeloActionBar-Container_cls2__4nwNf VeloActionBar-Container_cls1__eob+5"};